import { useCallback, useEffect, useState } from "react";
import { Check, X, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { MaterialRow } from "@/components/MaterialRow";
import { useAuth } from "@/context/AuthContext";
import { api, errText } from "@/lib/api";

const FILTERS = [["pending", "На проверке"], ["approved", "Одобренные"], ["rejected", "Отклонённые"]];
const btn = "inline-flex items-center gap-1 h-9 px-3 rounded-full text-sm font-semibold transition-colors";

export default function AdminFiles({ onChange }) {
  const { user } = useAuth();
  const [status, setStatus] = useState("pending");
  const [items, setItems] = useState(null);
  const load = useCallback(() => {
    api.get("/admin/materials", { params: { status } }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [status]);
  useEffect(() => { load(); }, [load]);

  const act = async (m, action) => {
    if (action === "delete" && !window.confirm(`Удалить «${m.title}»?`)) return;
    try {
      if (action === "delete") await api.delete(`/admin/materials/${m.id}`);
      else await api.post(`/admin/materials/${m.id}/${action}`);
      toast.success(action === "approve" ? `Одобрено. ${m.author} получил 50 коинов` : action === "reject" ? "Отклонено" : "Удалено");
      load(); onChange?.();
    } catch (e) { toast.error(errText(e)); }
  };

  return (
    <div>
      <div className="flex gap-2 flex-wrap">
        {FILTERS.map(([k, l]) => (
          <button key={k} onClick={() => setStatus(k)} data-testid={`admin-files-filter-${k}`}
            className={`px-4 py-2 rounded-full text-sm font-semibold border transition-colors ${status === k ? "bg-[#0b2e20] text-white border-[#0b2e20]" : "bg-white text-[#1f5f42] border-[#d1e7dd]"}`}>{l}</button>
        ))}
      </div>
      <div className="mt-5 space-y-3" data-testid="admin-files-list">
        {items && items.length === 0 && <p className="text-sm text-[#6b8a7b] py-10 text-center" data-testid="admin-files-empty">Здесь пусто</p>}
        {(items || []).map((m) => (
          <MaterialRow key={m.id} m={m} showSubject actions={<>
            {m.status === "pending" && <>
              <button onClick={() => act(m, "approve")} className={`${btn} bg-[#1f5f42] text-white hover:bg-[#174731]`} data-testid={`approve-material-${m.id}`}><Check className="h-4 w-4" />Одобрить</button>
              <button onClick={() => act(m, "reject")} className={`${btn} bg-red-50 text-red-700 hover:bg-red-100`} data-testid={`reject-material-${m.id}`}><X className="h-4 w-4" />Отклонить</button>
            </>}
            {user.role === "admin" && <button onClick={() => act(m, "delete")} className={`${btn} text-red-600 hover:bg-red-50 px-2`} title="Удалить" data-testid={`delete-material-${m.id}`}><Trash2 className="h-4 w-4" /></button>}
          </>} />
        ))}
      </div>
    </div>
  );
}
